import axios, { AxiosError } from "axios";
import { resetState } from "../slices/auth/authSlice";
import { store } from "../store/store";

var os = require("os");
var hostName = os.hostname();

const mainApi = axios.create({
  // baseURL: `http://157.100.65.115:4000/api/`,
  baseURL: `http://${hostName}:4000/api/`,
  timeout: 10000,
});

mainApi.interceptors.request.use(function (config) {
  let headers = { "x-token": localStorage.getItem("token") || "" };
  config.headers.set(headers);
  return config;
});

mainApi.interceptors.response.use(
  (response) => {
    return response;
  },
  async function (error) {
    let err = error as AxiosError;
    if (err.response && err.response.data) {
      let res: any = err.response.data;
      if ("msg" in res && res.msg === "Token no válido") {
        localStorage.clear();
        store.dispatch(resetState());
      }
    }
    return Promise.reject(error);
  }
);

export default mainApi;
